import { MdKeyboardArrowRight as RightArrowIcon } from 'react-icons/md'

export default RightArrowIcon;
